import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const createNewSalesAnalysisThread = (payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'CREATING_SALES_ANALYSIS_THREAD' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(`/cs/sale-review/upload`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'CREATING_SALES_ANALYSIS_THREAD_DONE',
              payload: {
                conversationId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'CREATING_SALES_ANALYSIS_THREAD_FAILED',
              payload: `Failed to create new sales analysis thread`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'CREATING_SALES_ANALYSIS_THREAD_FAILED',
            payload: `Failed to create new sales analysis thread`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'CREATING_SALES_ANALYSIS_THREAD_FAILED',
        payload: `Failed to create new sales analysis thread`,
      });
    }
  };
};

export default createNewSalesAnalysisThread;
